import { render, staticRenderFns } from "./AdminShippingEditDialog.vue?vue&type=template&id=ec495892&"
import script from "./AdminShippingEditDialog.vue?vue&type=script&lang=js&"
export * from "./AdminShippingEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdminShippingEditDialog.vue?vue&type=style&index=0&id=ec495892&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports